import * as yup from "yup";

export const petPackageSchema = yup.object().shape({
  title: yup.string().required("Title is required"),
  play_sku_id : yup.string().required("Play SKU ID required"),
  apple_sku_id : yup.string().required("Apple SKU ID required"),
  description: yup.string().required("Description is required"),
  slug: yup
    .string()
    .oneOf(["alert_customization", "pet_package"], "Please select a add on type")
    .required("Add On type is required"),
  price: yup
    .number()
    .typeError("Price must be a number")
    .min(0, "Price cannot be negative")
    .required("Price is required"),
  consent: yup.boolean().when("price", (price, schema, { context }) => {
    const defaultPrice = context?.defaultPrice ?? "";
    const hasChanged = price !== defaultPrice;
    return hasChanged
      ? schema.oneOf([true], "Consent is required when price is changed")
      : schema.notRequired();
  }),
});
